import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useLanguage } from '../context/LanguageContext';

export default function Sidebar({ collapsed, setCollapsed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const isMobile = useIsMobile();

  // Don't render on mobile (MobileNav handles that)
  if (isMobile) return null;

  const navItems = [
    { id: 'home', label: t('dashboard'), icon: '🔥', path: '/home' },
    { id: 'players', label: t('players'), icon: '👥', path: '/players' },
    { id: 'clans', label: t('clan'), icon: '🛡️', path: '/clans' }, 
    { id: 'profile', label: t('profile'), icon: '👤', path: '/profile' },
    { id: 'settings', label: t('settings'), icon: '⚙️', path: '/settings' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div style={{
      width: collapsed ? '80px' : '240px',
      height: '100vh',
      background: 'var(--card-bg)',
      borderRight: '1px solid var(--border)',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 1000,
      transition: 'width 0.3s ease',
    }}>
      {/* Logo Section */}
      <div style={{
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'space-between',
        padding: collapsed ? '0' : '0 20px',
        borderBottom: '1px solid var(--border)',
      }}>
        {!collapsed && (
          <div
            onClick={() => navigate('/home')}
            style={{
              fontSize: '22px',
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #38bdf8, #818cf8)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              cursor: 'pointer',
            }}
          >
            🔥 WWMMCGC
          </div>
        )}
        {collapsed && (
          <div
            onClick={() => navigate('/home')}
            style={{
              fontSize: '28px',
              cursor: 'pointer',
            }}
          >
            🔥
          </div>
        )}
        
        {/* Collapse Toggle */}
        <div
          onClick={() => setCollapsed(!collapsed)}
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            background: 'var(--bg)',
            color: 'var(--text)',
            fontSize: '12px',
            transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        >
          ◀
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '20px 12px' }}>
        {navItems.map((item) => (
          <div
            key={item.id}
            onClick={() => navigate(item.path)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: collapsed ? '0' : '14px',
              padding: '14px 16px',
              borderRadius: '12px',
              marginBottom: '8px',
              cursor: 'pointer',
              background: isActive(item.path) ? 'rgba(56, 189, 248, 0.1)' : 'transparent',
              color: isActive(item.path) ? '#38bdf8' : '#64748b',
              fontWeight: isActive(item.path) ? '600' : '500',
              transition: 'all 0.2s',
              justifyContent: collapsed ? 'center' : 'flex-start',
            }}
            onMouseEnter={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'var(--bg)';
                e.currentTarget.style.color = 'var(--text)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.color = '#64748b';
              }
            }}
            title={collapsed ? item.label : ''}
          >
            <span style={{ fontSize: '22px' }}>{item.icon}</span>
            {!collapsed && (
              <span style={{ fontSize: '15px', whiteSpace: 'nowrap' }}>
                {item.label}
              </span>
            )}
          </div>
        ))}
      </nav>

      {/* Footer / Version */}
      <div style={{
        padding: '20px',
        borderTop: '1px solid var(--border)',
        textAlign: 'center',
      }}>
        {collapsed ? (
          <span style={{ fontSize: '10px', color: '#64748b' }}>v1.0</span>
        ) : (
          <span style={{ fontSize: '12px', color: '#64748b' }}>
            WWMMCGC v1.0
          </span>
        )}
      </div>
    </div>
  );
}